import React, { Dispatch } from 'react';
import styled from 'styled-components';

import TextComponent from '@/components/TextComponent';
import VerificationForm, { FormType } from '@/components/VerificationForm';
import FormInputComponent from '@/components/FormInputComponent';
import { Control, FieldErrors, Controller } from 'react-hook-form';
import {
  validateEmail,
  validateName,
  validatePassword,
  validatePhone,
  validateUsername
} from '@/utils/validate';
import { SignupForm } from '@/apis/auth/interface';
import { useRecoilState } from 'recoil';
import { request } from '@/utils/request';
import { globalState } from '@/recoil/global';
import { ENDPOINTS } from '@/constants';

interface Props {
  display: boolean;
  control: Control<Record<string, any>>;
  errors: FieldErrors<SignupForm>;
  phoneAuth: boolean;
  setPhoneAuth: Dispatch<boolean>;
  setValue: any;
}

const BaseInfo = (props: Props) => {
  const { control, errors, phoneAuth, setPhoneAuth, setValue, display } = props;
  const [global, setGlobal] = useRecoilState(globalState);

  const onAuth = async (type: FormType, token: string, input: string) => {
    try {
      setGlobal({
        ...global,
        isLoading: true
      });
      const { data } = await request().put(ENDPOINTS.VERIFICATIONS_TOKEN, {
        type,
        target: input,
        token
      });

      if (data.success) {
        setPhoneAuth(true);
        setValue(type, input);
      }
    } catch (e) {
      // globalError.setError(e);
    } finally {
      setGlobal({
        ...global,
        isLoading: false
      });
    }
  };

  return (
    <InfoSection display={display}>
      <Top>
        <OrangeBar />
        <InfoSectionTitle>기본 정보</InfoSectionTitle>
      </Top>
      <Body>
        <FormInputComponent
          keyName="username"
          label={'아이디'}
          placeholder={'아이디를 입력해주세요. ( 최소 5자 이상 )'}
          defaultValue={''}
          control={control}
          error={errors.username}
          required={true}
          rules={{
            required: '아이디는 5자 이상 15자 이내로 입력해주세요',
            validate: validateUsername
          }}
          maxLength={15}
        />
        <FormInputComponent
          keyName="password"
          type="password"
          label={'비밀번호'}
          placeholder={'비밀번호를 입력해주세요. ( 최소 8자 이상 )'}
          defaultValue={''}
          control={control}
          error={errors.password}
          rules={{
            required: '비밀번호는 최소 8자 이상 20자 이하 입력해주세요',
            validate: validatePassword
          }}
          maxLength={20}
        />
        <FormInputComponent
          keyName="passwordCheck"
          type="password"
          label={'비밀번호 확인'}
          placeholder={'비밀번호를 입력해주세요. ( 최소 8자 이상 )'}
          defaultValue={''}
          control={control}
          error={errors.passwordCheck}
          rules={{
            required: '비밀번호는 최소 8자 이상 20자 이하 입력해주세요',
            validate: validatePassword
          }}
          maxLength={20}
        />
        <FormInputComponent
          keyName="pharmacistName"
          label={'이름'}
          placeholder={'이름을 입력해주세요.'}
          defaultValue={''}
          control={control}
          error={errors.pharmacistName}
          rules={{
            required: '이름을 입력해주세요',
            validate: validateName
          }}
          maxLength={10}
        />
        <Controller
          as={
            <VerificationForm
              type={'phone'}
              authType="join"
              onAuth={onAuth}
              placeholder="01012341234 ( - 없이, 숫자만 )"
              rules={{
                required: '휴대폰인증을 완료해주세요',
                validate: validatePhone
              }}
              authSuccess={phoneAuth}
            />
          }
          defaultValue={''}
          control={control}
          name={'phone'}
        />
        <FormInputComponent
          keyName="email"
          label={'이메일'}
          placeholder={'doctornow@gmail.com'}
          defaultValue={''}
          control={control}
          error={errors.email}
          rules={{
            required: '이메일 주소를 입력해주세요',
            validate: validateEmail
          }}
          maxLength={30}
        />
      </Body>
    </InfoSection>
  );
};

export default BaseInfo;

const InfoSection = styled.div<{ display: boolean }>`
  display: ${({ display }) => (display ? 'block' : 'none')};
`;
const Top = styled.div`
  display: flex;
  margin-bottom: 45px;
`;
const OrangeBar = styled.div`
  background: #ff8d00;
  width: 4px;
  margin-right: 8px;
`;
const InfoSectionTitle = styled(TextComponent)`
  font-size: 20px;
  font-weight: 700;
`;
const Body = styled.div`
  padding-left: 10px;
`;
